import { wageFrequencyToEnding } from "@/features/job-offer/utils/wage-frequency-to-ending";
import { WageFrequency } from "@api/shared-runtime/enums";

const formatAmount = (amount: number): string => {
  if (amount >= 5000) {
    return `${(amount / 1000).toFixed(0)}k`;
  }
  return amount.toLocaleString();
};

export const formatSalary = ({
  wageMinAmount,
  wageMaxAmount,
  wageFrequencyId,
}: {
  wageMinAmount?: string | null;
  wageMaxAmount?: string | null;
  wageFrequencyId?: WageFrequency | null;
}) => {
  if (!wageFrequencyId || (!wageMinAmount && !wageMaxAmount)) {
    return "Compensation details unavailable";
  }

  if (wageMinAmount && wageMaxAmount) {
    if (wageMinAmount === wageMaxAmount) {
      return `${formatAmount(Number(wageMinAmount))}${wageFrequencyToEnding[wageFrequencyId]}`;
    }
    return `${formatAmount(Number(wageMinAmount))} - ${formatAmount(Number(wageMaxAmount))}${wageFrequencyToEnding[wageFrequencyId]}`;
  }

  if (wageMinAmount) {
    return `${formatAmount(Number(wageMinAmount))}${wageFrequencyToEnding[wageFrequencyId]}`;
  }

  if (wageMaxAmount) {
    return `${formatAmount(Number(wageMaxAmount))}${wageFrequencyToEnding[wageFrequencyId]}`;
  }

  return "Compensation details unavailable";
};
